import { State } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
  ProductBuilderMachineStateSchema,
} from '../types';
import { getStateKey } from './getStateKey';

type StateHasValue = (
  state: State<
    ProductBuilderMachineContext,
    ProductBuilderMachineEvent,
    ProductBuilderMachineStateSchema
  >,
) => boolean;

export const stateHasValue: StateHasValue = state => {
  const { custom } = state.context;
  const key = getStateKey(state.value);
  const value = custom[key];
  const isArray = Array.isArray(value);

  // Special-case: wand option should allow navigation by default
  if (key === 'wand_option') {
    return true;
  }

  // Special-case: wand_colour should allow navigation when it has a valid value (including 'white', 'black', or 'no')
  if (key === 'wand_colour') {
    return value && typeof value === 'string' && value.length > 0;
  }

  // Special-case: trackColour should allow navigation when trackRequire is 'No' or when trackColour has a value
  if (key === 'trackColour') {
    const trackRequire = state.context.custom.trackRequire;
    if (trackRequire === 'No') {
      return true; // Allow navigation if No track is selected
    }
    return value && typeof value === 'string' && value.length > 0;
  }

  // Special-case: trackRequire should always allow navigation (for curtain types)
  if (key === 'trackRequire') {
    return value && typeof value === 'string' && value.length > 0;
  }

  return isArray
    ? typeof value[0] === 'number'
    : value && typeof value !== 'undefined';
};
